module.exports = __webpack_public_path__ + "img/AI_18.0ae12eb9.png";